export const LEASING_EXPENSES_UPDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Financials.LeasingExpensesUpdated";
export const OFFER_LEASING_EXPENSES_INVALIDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Financials.OfferLeasingExpensesInvalidated";
